import { Helper } from "../util/helper.js";
import { Config } from "../config/config.js";
import React from "react";
export class Validator extends React.Component<ValidatorProps, any>{
    private _validator: kendo.ui.Validator;
    private _validatorRef: HTMLFormElement = null;


    private _setFormRef = (r: HTMLFormElement) => {
        this._validatorRef = r;
    }

    private _getMessage = (input, msg: string) => {
        return Helper.formatString(msg, input.data("label"));//   Config.translations.mandatoryField.replace("{0}", );
    }


    componentDidMount() {
        this._validator = $(this._validatorRef).kendoValidator({
            rules: {
                multipleRadiosAndCheckboxes: function (e) {
                    const $e = $(e);
                    const $rbp = $e.parent(".multiple-radio-buttons__container");
                    const $cbp = $e.parent(".multiple-checkBoxes__container");

                    if ($rbp.length === 1) {
                        const reqrb = $("input[type=radio][required]", $rbp);
                        if (reqrb.length > 0) {
                            return reqrb.filter(":checked").length > 0;
                        } else {
                            return true;
                        }
                    } else if ($cbp.length === 1) {
                        const reqcb = $("input[type=checkbox][required]", $cbp);
                        if (reqcb.length > 0) {
                            return reqcb.filter(":checked").length > 0;
                        } else {
                            return true;
                        }
                    }

                    return true;
                }
            },
            messages: {
                required: (input) => {
                    return this._getMessage(input, Config.translations.mandatoryField);
                },
                multipleRadiosAndCheckboxes: (input) => {
                    return this._getMessage(input, Config.translations.atLeastOne);
                },
                min: (input) => {
                    return Config.translations.minValue;
                },
                max: (input) => {
                    return Config.translations.maxValue;
                },
                email: (input) => {
                    return this._getMessage(input, Config.translations.validEmail);
                }
            }
        }).data("kendoValidator");
        this.props.onCreateValidator(this._validator);
    }

    render() {
        return (
            <form className="flex-container__item" onSubmit={(e) => e.preventDefault()} ref={this._setFormRef}>{this.props.children}</form>
        );
    }
};

interface ValidatorProps extends React.PropsWithChildren {
    onCreateValidator(validator: any);
}